import { render, staticRenderFns } from "./NominativesSeatsio.vue?vue&type=template&id=9fe42db4&"
import script from "./NominativesSeatsio.vue?vue&type=script&lang=js&"
export * from "./NominativesSeatsio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports